/** @jsxImportSource @emotion/react */
import { useTheme } from "basis";
import { itemToString } from "components/AutoAddress/utils";
import { SvgInline } from "components/SvgInline/SvgInline";
import { SearchAddress } from "./api/addressApi";

// 🦘 inspired by: https://github.com/facebook/react/issues/3386#issuecomment-351757615
const formatMarkedText = (text, values, regex) => {
  if (!values.length) {
    return text;
  }

  return (
    <div>
      {text.split(regex).reduce((prev, current, i) => {
        if (!i) return [current];

        return prev.concat(
          values.includes(current) ? (
            <b key={i + current}>{current}</b>
          ) : (
            current
          ),
        );
      }, [])}
    </div>
  );
};

interface Props {
  inputValue: string;
  item: SearchAddress;
}
export const BoldLineItem = ({ inputValue: q, item }: Props) => {
  const query = q.trim();
  const text = itemToString(item);
  const theme = useTheme();

  if (!query) return text;
  const markingRegex = new RegExp(query, "gi");

  const boldingValues: string[] = [];
  const markedText = text.replace(markingRegex, (str) => {
    boldingValues.push(str);
    return `[[${str}]]`;
  });

  const reg = new RegExp(/\[\[(.*?)\]\]/, "gi"); // Match text inside two square brackets
  return (
    <>
      <SvgInline
        name="core-location"
        size="32"
        css={{ marginRight: theme.space["2"] }}
      />
      {formatMarkedText(markedText, boldingValues, reg)}
    </>
  );
};
